var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-switcher", {
    attrs: {
      "trigger-color": _vm.header ? _vm.header.accentColor : "",
      components: _vm.workspaceComponentsByKey,
      workspaces: _vm.workspacesById,
      "default-workspaces": _vm.defaultWorkspacesById,
      "active-workspace": _vm.activeWorkspace ? _vm.activeWorkspace.key : "",
    },
    on: {
      "link-click": _vm.onActiveWorkspaceChange,
      "layout-select": _vm.onLayoutSelect,
      "layout-bookmark": _vm.onLayoutBookmark,
      "layout-reset": _vm.onLayoutReset,
      "layout-delete": _vm.onLayoutDelete,
      "layout-create": _vm.onLayoutCreate,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }